import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./boot.css";
import "./index.css";

// Load buffer polyfill first
import "@/lib/buffer-polyfill";

// Suppress Vite HMR WebSocket errors in development (before app loads)
if (import.meta.env.DEV) {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const message = args[0]?.toString?.() || '';
    if (message.includes('WebSocket') && message.includes('wss://localhost:undefined')) {
      return; // Suppress this specific HMR error
    }
    originalConsoleError.apply(console, args);
  };

  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || event.reason?.toString?.() || '';
    if (message.includes('WebSocket') && message.includes('wss://localhost:undefined')) {
      event.preventDefault();
      return;
    }
  });
}

// Initialize app
function initializeApp() {
  const root = document.getElementById('root');
  if (!root) {
    console.error('Root element not found');
    return;
  }

  createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Auto-initialize on page load
if (!document.getElementById('ohio-loader')) {
  initializeApp();
}
